import { useLanguage } from "../i18n/LanguageContext";
import { useSEO } from "../hooks/useSEO";
import { Hero } from "../components/home/Hero";
import { USPs } from "../components/home/USPs";
import { ServicesPreview } from "../components/home/ServicesPreview";
import { Gallery } from "../components/home/Gallery";
import { PhotoCarousel } from "../components/home/PhotoCarousel";
import { About } from "../components/home/About";
import { Reviews } from "../components/home/Reviews";
import { OpeningHoursSection } from "../components/home/OpeningHoursSection";
import { LocationSection } from "../components/home/LocationSection";
import { CTASection } from "../components/home/CTASection";

export default function Home() {
  const { lang } = useLanguage();
  useSEO(
    lang === "nl"
      ? "EliteTheBarber | Kapper & Barbershop Utrecht – Boek online"
      : "EliteTheBarber | Barbershop Utrecht – Book online",
    lang === "nl"
      ? "Premium kapper in Utrecht aan de Vlampijpstraat 75g. Knippen, baard trimmen en meer. Boek eenvoudig online je afspraak bij EliteTheBarber."
      : "Premium barbershop in Utrecht on Vlampijpstraat 75g. Haircuts, beard grooming and more. Book your appointment online at EliteTheBarber."
  );

  return (
    <div data-testid="home-page">
      <Hero />
      <USPs />
      <ServicesPreview />
      <Gallery />
      <PhotoCarousel />
      <About />
      <Reviews />
      <OpeningHoursSection />
      <LocationSection />
      <CTASection />
    </div>
  );
}
